import { type GraphQLResult } from './apiClient';
import { getApiClient } from './apiClient';

interface DashboardStatsData {
  userStats: {
    month: string;
    newUsers: number;
  }[];
  licenseStats: {
    month: string;
    totalLicenses: number;
    totalDuration: number;
    model: string;
  }[];
  activeLicenses: {
    type: string;
    count: number;
  }[];
  allLicenses: {
    type: string;
    count: number;
  }[];
}

/**
 * The worker returns the stats object directly. It is NOT wrapped in the
 * `{ result, data }` envelope AppSync used to add — unwrapping one level too
 * far here is what made the Dashboard read `userStats` off `undefined`.
 */
interface GetDashboardStatsResponse {
  getDashboardStats: DashboardStatsData;
}

const getDashboardStatsQuery = /* GraphQL */ `
  query GetDashboardStats {
    getDashboardStats {
      result
      data {
        userStats {
          month
          newUsers
        }
        licenseStats {
          month
          totalLicenses
          totalDuration
          model
        }
        activeLicenses {
          type
          count
        }
        allLicenses {
          type
          count
        }
      }
    }
  }
`;

export const dashboardService = {
  async getDashboardStats(): Promise<DashboardStatsData> {
    try {
      const response = await getApiClient().graphql({
        query: getDashboardStatsQuery
      }) as GraphQLResult<GetDashboardStatsResponse>;

      if (response.errors) {
        throw new Error(response.errors.map(e => e.message).join(', '));
      }

      const stats = response.data?.getDashboardStats;
      if (!stats) throw new Error('No data returned');
      return stats;
    } catch (error) {
      console.error('Error in getDashboardStats:', error);
      throw error;
    }
  }
};